import * as React from 'react';
import {
  BatchActionType,
  useBatchActionsContext
} from '@common/context/batchActionsContext';
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import AssignModal from '@pages/CareerServices/ExternshipTrackerPage/AssignModal';
import EmailBatchModal from '@pages/CareerServices/ExternshipTrackerPage/EmailBatchModal';
import { styled } from '@mui/system';

const Styled = {
  BatchActionsWrapper: styled(Box)({
    display: 'flex',
    gap: '1em',
    ['@media (max-width:599px)']: {
      flexDirection: 'column'
    }
  }),
  BatchActionsLabel: styled(Typography)(({ theme }) => ({
    marginBottom: '5px',
    textTransform: 'uppercase',
    color: theme.palette.grey4.main
  })),
  FormControl: styled(FormControl)({
    minWidth: '200px',
    ['@media (max-width:599px)']: {
      minWidth: 'unset'
    }
  }),
  Select: styled(Select)(({ theme }) => ({
    '.MuiSelect-select': {
      color: theme.palette.GRAY_3.main
    }
  })),
  Button: styled(Button)({
    minWidth: '100px'
  })
};

const BatchActions: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    actions,
    actionSelectLabel,
    rowSelectionModel,
    actionBtnText,
    modalOpen,
    selectedAction,
    handleOpenModal,
    handleSetSelectedAction
  } = useBatchActionsContext();

  const handleActionBtnClick = React.useCallback(() => {
    handleOpenModal();
  }, [handleOpenModal]);

  return (
    <Styled.BatchActionsWrapper alignItems={actionSelectLabel === ''  ? 'center' : 'flex-end'} justifyContent={actionSelectLabel === ''  ? 'center' : 'flex-end'}>
      <Styled.FormControl fullWidth={isMobile}>
        {actionSelectLabel &&
          <Styled.BatchActionsLabel variant="EC_TYPE_XS">
            {actionSelectLabel}
          </Styled.BatchActionsLabel>
        }
        <Styled.Select
          onChange={(e: SelectChangeEvent<any>): void =>
            handleSetSelectedAction(e)
          }
          value={selectedAction?.value ?? ''}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return <Typography color="text.secondary">Bulk Actions</Typography>;
            }
            return actions.find(action => action.value === selected)?.label;
          }}
        >
          {actions.map((action) => (
            <MenuItem key={action.label} value={action.value}>
              {action.label}
            </MenuItem>
          ))}
        </Styled.Select>
      </Styled.FormControl>
      <Styled.Button
        variant="contained"
        fullWidth={isMobile}
        onClick={handleActionBtnClick}
        disabled={!rowSelectionModel?.length || !selectedAction?.value}
      >
        {actionBtnText}
      </Styled.Button>
      <AssignModal open={modalOpen === BatchActionType.ASSIGN} />
      <EmailBatchModal 
        open={(modalOpen === BatchActionType.EMAIL_STUDENT 
          || modalOpen === BatchActionType.EMAIL_MANAGER
          || modalOpen === BatchActionType.EMAIL_APPROVERS)} 
        batchActionType={modalOpen || BatchActionType.EMAIL_STUDENT}
      />
    </Styled.BatchActionsWrapper>
  );
};

export default BatchActions;
